import { HomeFilled } from "@ant-design/icons";

import DragAndDrop from "@/components/Elements/DragAndDrop";
import { SchemaBuilderFieldRow } from "@/modules/schema-builder/schema-builder-field-row";

import Group from "./Group";

const MovableElements = ({
  schema,
  activeNode,
  onGroupCopy,
  onDeleteGroup,
  onGroupRename,
  onFieldUpdate,
  onFieldDelete,
  onAddField,
  onAddFieldToGroup,
  onFieldCopy,
}) => {
  /**
   * Returns the list of visible fields with their evaluated values
   * @param {array} fields
   * @param {string} path
   *
   * @return {array}
   */
  const fields = (fields, path) =>
    fields?.map((field, key) => {
      const fieldPath = `${path}[${key}]`;
      return (
        <DragAndDrop.Sortable
          key={field.model}
          id={field.model}
          path={fieldPath}
        >
          <SchemaBuilderFieldRow
            schema={field}
            isActive={activeNode?.model === field.model}
            onFieldUpdate={(modifiedField) =>
              onFieldUpdate(modifiedField, fieldPath)
            }
            onDeleteClick={() => onFieldDelete(field, fieldPath)}
            onCopyClick={() => onFieldCopy(field, fieldPath)}
          />
        </DragAndDrop.Sortable>
      );
    });

  const UngroupedFields = ({ schema }) => {
    const fieldsPath = `fields`;
    return (
      <DragAndDrop.Droppable key="ungrouped" id="ungrouped" path={fieldsPath}>
        <Group.Preview
          legend={<HomeFilled />}
          fields={fields(schema?.fields, fieldsPath)}
          onAddField={onAddField}
        />
      </DragAndDrop.Droppable>
    );
  };

  const Groups = ({ schema }) =>
    schema?.groups?.map((group, key) => {
      const groupPath = `groups[${key}]`;
      const fieldsPath = `${groupPath}.fields`;
      const { readonly, unclonable } = group;

      return (
        <DragAndDrop.Droppable
          key={group.legend}
          id={group.legend}
          path={fieldsPath}
        >
          <Group.Preview
            legend={group.legend}
            fields={fields(group.fields, fieldsPath)}
            notAllowedGroupNames={schema.groups}
            onGroupRename={readonly ? undefined : onGroupRename}
            onGroupCopy={unclonable ? undefined : onGroupCopy}
            onAddField={readonly ? undefined : onAddFieldToGroup}
            onDeleteGroup={onDeleteGroup}
          />
        </DragAndDrop.Droppable>
      );
    });

  return (
    <>
      {UngroupedFields({ schema })}
      {Groups({ schema })}
    </>
  );
};

export default MovableElements;
